module.exports = __webpack_public_path__ + "img/s-1.91e5fbb9.png";